/**
 * <sticky-size-picker> renders quick size buttons inside the mobile sticky
 * add-to-cart bar. Clicking a size doesn't reimplement variant selection —
 * it finds the matching input in the page's real variant picker and clicks
 * it, so the theme's existing variant-select flow (price/image/morph of the
 * sticky bar) runs exactly as it would from the main product form.
 */
class StickySizePicker extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  /** @param {MouseEvent} event */
  #handleClick = (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-value]') : null;
    if (!button) return;

    const value = button.getAttribute('data-value');
    const optionName = this.dataset.optionName;
    const productId = this.dataset.productId;
    if (!value || !optionName || !productId) return;

    const picker = document.querySelector(`variant-picker[data-product-id="${productId}"]`);
    if (!picker) return;

    const input = /** @type {HTMLInputElement | null} */ (
      picker.querySelector(`input[data-option-name="${CSS.escape(optionName)}"][value="${CSS.escape(value)}"]`)
    );
    if (!input || input.disabled) return;

    input.click();
    input.dispatchEvent(new Event('change', { bubbles: true }));

    this.querySelectorAll('[data-value]').forEach((el) => {
      el.classList.toggle('sticky-add-to-cart__size-button--selected', el === button);
    });
  };
}

if (!customElements.get('sticky-size-picker')) {
  customElements.define('sticky-size-picker', StickySizePicker);
}
